module.exports = __webpack_public_path__ + "img/vi.5c4674aa.svg";